import { callApi } from '@/helpers/api';
import CONFIG from '@/config/global';

const { api: { PROXY_HOST, GET_STORIES } } = CONFIG;

const getStories = () => {
  return callApi({ url: PROXY_HOST(GET_STORIES) + GET_STORIES });
};

export default getStories;